export const LOAD_PURCHASES = 'purchases/LOAD_PURCHASES';
export const LOAD_PURCHASES_SUCCESS = 'purchases/LOAD_PURCHASES_SUCCESS';
export const LOAD_PURCHASES_ERROR = 'purchases/LOAD_PURCHASES_ERROR';
export const SAVE_PURCHASE_REQUEST = 'purchases/SAVE_PURCHASE_REQUEST';
export const PAY_PURCHASE_REQUEST = 'purchases/PAY_PURCHASE_REQUEST';
export const CANCEL_PURCHASE_REQUEST = 'purchases/CANCEL_PURCHASE_REQUEST';
